module.exports = __webpack_public_path__ + "static/media/The_hypno_virus_controls_me.7cd4e727.mp3";